<template>
  <!-- 議案總表 -->
  <div id="TopicDetailDialog_main">
    <el-dialog
      title="檢視議案"
      :visible.sync="dialogVisible"
      width="60%"
      @close="data = {}"
    >
      <div v-loading="loading">
        <div
          v-if="data.progressStatus !== 'voting' && data.progressStatus !== 'decided'"
          class="right"
        >
          <el-button
            type="primary"
            size="medium"
            plain
            @click="submit('編輯')"
          >
            編輯
          </el-button>
          <el-button
            type="danger"
            size="medium"
            plain
            @click="submit('刪除')"
          >
            刪除
          </el-button>
        </div>
        <el-form
          v-if="data"
          label-position="left"
          label-width="120px"
          :model="data"
        >
          <el-form-item label="議案名稱">
            {{ data.title }}
          </el-form-item>
          <el-form-item label="議案說明">
            {{ data.description }}
          </el-form-item>
          <el-form-item label="出席門檻">
            {{ threshold(data.attendanceThreshold) }}％
          </el-form-item>
          <el-form-item label="通過門檻">
            {{ threshold(data.consentThreshold) }}％
          </el-form-item>
          <el-form-item label="記名／匿名">
            <span v-if="data.progressStatus == 'met' || data.progressStatus == 'notmet'">－</span>
            <span v-else>{{ data.isAnonymous ? '匿名' : '記名' }}</span>
          </el-form-item>
          <el-form-item label="議案狀態">
            {{ progressStatus(data.progressStatus) }}
          </el-form-item>
          <el-form-item
            v-if="data.progressStatus == 'decided'"
            label="表決結果"
          >
            {{ data.decisionContent }}
          </el-form-item>
        </el-form>
        <p class="editingRecordTitle">
          異動紀錄
        </p>
        <el-table
          :data="data.editingRecords"
          style="width: 100%"
        >
          <el-table-column
            prop="editAt"
            label="時間"
            min-width="50px"
          />
          <el-table-column
            prop="note"
            label="原因"
            min-width="100px"
          />
        </el-table>
      </div>
    </el-dialog>
    <TopicEditDialog
      ref="topicEditDialog"
      :main-threshold="mainThreshold"
      @refresh="getTopic"
    />
  </div>
</template>
<script>
import TopicEditDialog from './TopicEditDialog.vue'

export default {
  components: {
    TopicEditDialog
  },
  props: {
    mainThreshold: Number
  },
  data () {
    return {
      dialogVisible: false,
      topicId: '',
      data: {},
      loading: false
    }
  },
  methods: {
    openDialog (id) {
      this.data = {}
      this.dialogVisible = true
      this.topicId = id
      this.getTopic(id)
    },
    // 取得議案資料
    getTopic (id) {
      this.loading = true
      apiUnitOwnerAssembly.Topic.GetTopic(
        {
          AssemblyId: this.$route.params.id,
          TopicId: id
        }
      ).then(res => {
        console.log(res)
        this.data = res.data.topic
        this.loading = false
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
        this.loading = false
      })
      this.$emit('refresh')
    },
    submit (action) {
      // eslint-disable-next-line eqeqeq
      if (action == '編輯') {
        const data = _cloneDeep(this.data)
        data.attendanceThreshold = this.threshold(data.attendanceThreshold)
        data.consentThreshold = this.threshold(data.consentThreshold)
        this.$refs.topicEditDialog.openDialog(data)
      } else {
        this.deleteTopic(this.topicId)
      }
    },
    // 刪除議案
    deleteTopic (id) {
      this.$confirm('確認是否刪除？', '', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apiUnitOwnerAssembly.Topic.DeleteTopic(
          {
            'content-type': 'application/json',
            data: {
              assemblyId: this.$route.params.id,
              topicId: id
            }
          }
        ).then(res => {
          console.log(res)
          // eslint-disable-next-line eqeqeq
          if (res.status == 200) {
            this.$message.success('議案刪除成功')
            this.dialogVisible = false
            this.$emit('refresh')
          }
        }).catch((err) => {
          console.log('錯誤訊息：', err.response)
        })
      }).catch(() => {})
    },
    threshold (attendanceThreshold) {
      return parseFloat((attendanceThreshold * 100).toPrecision(12))
    },
    progressStatus (string) {
      return ['未達門檻', '已達門檻', '表決中', '已表決'][['notmet', 'met', 'voting', 'decided'].indexOf(string)]
    }
  }
}
</script>
<style lang="sass" scoped>
#TopicDetailDialog_main
  ::v-deep .el-dialog
    +basicDialog
    min-width: 640px
    .el-dialog__body
      padding-top: 25px
      .right
        float: right
        margin-bottom: 10px
    .el-form
      text-align: left
      .el-form-item
        margin-bottom: 15px
        .el-form-item__label
          font-weight: bold
          margin-right: 0
          padding-right: 32px
    .editingRecordTitle
      text-align: left
      font-size: 15px
      font-weight: bold
      line-height: 30px
      color: $mainFontColor
      margin-bottom: 15px
    ::v-deep .el-table
      +basicTable
</style>
